import { RootState } from '@/modules/ewwms/store';
import { ActionContext, ActionTree } from 'vuex';
import { Mutations, MutationTypes } from './mutations';
import { State } from './state';

import { useEwwmsCommonStore } from '../../ewwmsCommonStore';

import ApiService from '@/modules/ewwms/services/ApiService';
import { Artikel } from '@/modules/ewwms/models/Lager/ArtikelModels';

export enum ActionTypes {
  GetArtikel = 'GETARTIKEL',
}

type ActionArguments = Omit<ActionContext<State, RootState>, 'commit'> & {
  commit<K extends keyof Mutations>(key: K, payload?: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
};

export type Actions = {
  [ActionTypes.GetArtikel](context: ActionArguments): Promise<void>;
};

export const actions: ActionTree<State, RootState> & Actions = {
  async [ActionTypes.GetArtikel]({ commit }) {
    const commonStore = useEwwmsCommonStore();
    const status = commonStore.status;
    status.getArtikelLoading = true;
    status.artikelErrorMsg = '';
    commonStore.setStatus(status);

    commit(MutationTypes.SetArtikel, new Array<Artikel>());

    return ApiService.getArtikel()
      .then((res) => {
        const artikel: Array<Artikel> = res.data;
        commit(MutationTypes.SetArtikel, artikel);
      })
      .catch((error) => {
        status.artikelErrorMsg = error.toString();
      })
      .finally(() => {
        status.getArtikelLoading = false;
        commonStore.setStatus(status);
      });
  },
};
